import {getDataSectionSlice} from 'src/hooks/common-data-service/data-section';
import {
    getProfileChangeEventFailure,
    getProfileChangeEventRequest,
    getProfileChangeEventSuccess,
} from 'src/openapi/admin/apis/ProfileChangeHistoryApi';

import type {DataSectionSelector} from 'src/hooks/common-data-service/data-section';
import type {GetProfileChangeEvent$Request} from 'src/openapi/admin/apis/ProfileChangeHistoryApi';
import type {ProfileChangeEvent} from 'src/openapi/admin/models/ProfileChangeEvent';

export const profileHistoryRecordSlice = getDataSectionSlice<
    ProfileChangeEvent,
    GetProfileChangeEvent$Request,
    undefined
>({
    name: 'roleProfileHistoryRecord',
    initialData: {
        eventId: 0,
        profileId: 0,
        profileName: '',
        profileDescription: '',
        rightsCodes: [],
        editor: {
            accountId: 0,
            userId: 0,
            firstName: '',
            lastName: '',
            email: '',
            isDeleted: false,
        },
        notes: '',
        operationDescription: '',
        eventTime: '',
    },

    getActionRequest: getProfileChangeEventRequest,
    getActionSuccess: getProfileChangeEventSuccess,
    getActionFailure: getProfileChangeEventFailure,
});

export const profileHistoryRecordActions = profileHistoryRecordSlice.actions;
export const selectProfileHistoryRecord: DataSectionSelector<ProfileChangeEvent> = state =>
    state.adminRights.profileHistory.historyRecord;
